import * as React from "react";
import classnames from "classnames";
import { Heading } from "@grandvisionhq/elements";
import ProductOffer from "../ProductOffer/ProductOffers/ProductOffer/ProductOffer.js";
/* empty css                   */
const ProductOffers = ({
  className,
  labels,
  offers,
  fallbackImage,
  linkTarget,
  ...rest
}) => {
  return /* @__PURE__ */ React.createElement("div", { ...rest, className: classnames("product-offers", className) }, /* @__PURE__ */ React.createElement(Heading, { variant: "smallest", component: "h3" }, labels.title), /* @__PURE__ */ React.createElement("div", { className: "product-offers__items" }, offers.map(({ title, description, url, imageUrl }) => /* @__PURE__ */ React.createElement(
    ProductOffer,
    {
      key: title,
      className: "product-offers__offer",
      title,
      description,
      url,
      imageUrl,
      fallbackImageUrl: fallbackImage,
      linkTarget
    }
  ))));
};
export {
  ProductOffers as default
};
//# sourceMappingURL=ProductOffers.js.map
